export class ReportModule {
    ID: number;
    Description: string;
    IsSelected: boolean;
}

